// extracted by mini-css-extract-plugin
export var askAiIcon = "_n5-9";
export var container = "_n5-0";
export var groupSeparator = "_n5-a";
export var highlight = "_n5-4";
export var resultIcon = "_n5-5";
export var resultItem = "_n5-7";
export var resultSubtitle = "_n5-3";
export var resultTitle = "_n5-2";
export var resultsList = "_n5-1";
export var searchGroup = "_n5-6";
export var selected = "_n5-8";